import { useCallback } from "preact/hooks";
import PropTypes from "prop-types";
import tiltifyLogo from "@/assets/logos/tiltify-logo.png";
import tiltifyLogoWhite from "@/assets/logos/tiltify-logo-white.png";
import twitchLogo from "@/assets/logos/twitch-logo.png";
import twitchLogoWhite from "@/assets/logos/twitch-logo-white.png";
import { CHARITY } from "@/util/const.js";

export default function CharityPicker({ onChange, charityType }) {
  const handleCharityTwitch = useCallback(() => {
    onChange({ target: { value: CHARITY.TWITCH, name: "charityType" } });
  }, [onChange]);

  const handleCharityTiltify = useCallback(() => {
    onChange({ target: { value: CHARITY.TILTIFY, name: "charityType" } });
  }, [onChange]);

  return (
    <div className="w-full flex join">
      <button
        type="button"
        className={`btn btn-lg join-item flex-grow overflow-hidden btn-tiltify-charity ${charityType === CHARITY.TILTIFY && "btn-tiltify-charity-selected"}`}
        onClick={handleCharityTiltify}
      >
        {charityType !== CHARITY.TILTIFY && (
          <img className="w-8 h-8" src={`${tiltifyLogo}`} alt="Tiltify" />
        )}
        {charityType === CHARITY.TILTIFY && (
          <img className="w-8 h-8" src={`${tiltifyLogoWhite}`} alt="Tiltify" />
        )}
        <span className="ml-2 text-2xl">Tiltify</span>
      </button>

      <button
        type="button"
        className={`btn btn-lg join-item flex-grow overflow-hidden btn-twitch-charity ${charityType === CHARITY.TWITCH && "btn-twitch-charity-selected"}`}
        onClick={handleCharityTwitch}
      >
        {charityType !== CHARITY.TWITCH && (
          <img className="w-8 h-8" src={`${twitchLogo}`} alt="Twitch" />
        )}
        {charityType === CHARITY.TWITCH && (
          <img className="w-8 h-8" src={`${twitchLogoWhite}`} alt="Twitch" />
        )}
        <span className="ml-2 text-2xl">Twitch</span>
      </button>
    </div>
  );
}

CharityPicker.propTypes = {
  onChange: PropTypes.func,
  charityType: PropTypes.string,
};

CharityPicker.defaultProps = {
  charityType: CHARITY.TWITCH,
};
